<template>
  <div class="clientiadd">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Registra un cliente</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="codice" v-model="formData.cliente.codice" type="text" :state="state.codice" placeholder="Codice del cliente" /><label for="codice">Codice *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="8">
          <b-form-select class="slide-up" id="idTipocliente" v-model="formData.cliente.idTipocliente" :options="option.tipoclienti" :state="state.idTipocliente" placeholder="Tipologia di cliente" /><label for="idTipocliente">Tipologia Cliente*</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="denominazione" v-model="formData.cliente.denominazione" type="text" :state="state.denominazione" placeholder="Denominazione del cliente" /><label for="denominazione">Denominazione *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cf" v-model="formData.cliente.cf" type="text" :state="state.cf" placeholder="Codice fiscale del cliente" /><label for="cf">Codice Fiscale *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="piva" v-model="formData.cliente.piva" type="text" :state="state.piva" placeholder="Partita IVA del cliente" /><label for="piva">Partita IVA</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>REFERENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cont1" v-model="formData.cliente.cont1" type="text" :state="state.cont1" placeholder="Contatto principale del cliente" /><label for="cont1">Principale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cont2" v-model="formData.cliente.cont2" type="text" :state="state.cont2" placeholder="Contatto secondario del cliente" /><label for="cont2">Secondario</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>RESIDENZA/UBICAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" style="float: right" v-on:click="openModalAggiungiIndirizzo()"><font-awesome-icon icon="search-location" /> Aggiungi Indirizzo</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="formData.cliente.indirizzi"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" v-on:click="openModalAggiungiIndirizzo(row.item)"><font-awesome-icon icon="edit" /></b-button>
              <b-button size="sm" style="margin-left: 10px;" variant="danger" v-on:click="openModalDeleteIndirizzo(row.item)"><font-awesome-icon icon="times" /></b-button>
            </template>

            <template slot="residenza" slot-scope="row">
              <p v-if="row.item.residenza"><font-awesome-icon icon="home" /> Residenza</p>
              <p v-if="!row.item.residenza"><font-awesome-icon icon="map-marker-alt" /> Ubicazione</p>
            </template>

            <template slot="indirizzo" slot-scope="row">
              {{row.item.via}} {{row.item.civico}}, {{row.item.cap}} {{row.item.comune}}({{row.item.provincia}}), {{(row.item.nazione.slice(0, 2) == "M_") ? row.item.nazione.slice(2) : row.item.nazione}}
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>ALTRE INFORMAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="website" v-model="formData.cliente.website" type="text" :state="state.website" placeholder="Sito web del cliente" /><label for="website">Sito web</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="formData.cliente.email" type="text" :state="state.email" placeholder="Email del cliente" /><label for="email">Email</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="cellulare" v-model="formData.cliente.cellulare" type="text" :state="state.cellulare" placeholder="Numero di cellulare del cliente" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="telefono" v-model="formData.cliente.telefono" type="text" :state="state.telefono" placeholder="Numero del telefono fisso del cliente" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="fax" v-model="formData.cliente.fax" type="text" :state="state.fax" placeholder="Numero del Fax del cliente" /><label for="fax">Fax</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.cliente.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="addCliente()"><font-awesome-icon icon="plus-circle" /> Crea</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>

    <b-modal v-model="modal.indirizzo" size="xl" title="Aggiungi indirizzo">
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12" lg="8">
              <b-form-input class="slide-up" id="search_box" type="search" :state="modalState.search_address" placeholder="Indirizzo del cliente" autocomplete="off"/><label for="search_box">* Indirizzo</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-radio-group v-model="modalData.indirizzo.residenza" buttons>
                <b-form-radio :value="true" button-variant="outline-success">Residenza</b-form-radio>
                <b-form-radio :value="false" button-variant="outline-danger">Ubicazione</b-form-radio>
              </b-form-radio-group>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div id="ubicazione_map"></div>
              <br>
              <br>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <b-col cols="12" md="9">
              <b-form-input class="slide-up" id="via" v-model="modalData.indirizzo.via" type="text" :state="state.via" placeholder="Via dell'installatore" /><label for="via">Via *</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-input class="slide-up" id="civico" v-model="modalData.indirizzo.civico" type="text" :state="state.civico" placeholder="Civico dell'installatore"/><label for="civico">Civico *</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="comune" v-model="modalData.indirizzo.comune" type="text" :state="state.comune" placeholder="Comune dell'installatore" /><label for="comune">Comune *</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="cap" v-model="modalData.indirizzo.cap" type="text" :state="state.cap" placeholder="CAP dell'installatore"/><label for="cap">CAP *</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="provincia" v-model="modalData.indirizzo.provincia" type="text" :state="state.provincia" placeholder="Provincia dell'installatore" /><label for="provincia">Provincia *</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="nazione" v-model="modalData.indirizzo.nazione" type="text" :state="state.nazione" placeholder="Nazione dell'installatore"/><label for="nazione">Nazione *</label>
              <br>
              <br>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-select class="slide-up" id="idTipoluogo" v-model="modalData.indirizzo.idTipoluogo" :options="option.tipoluogo" :state="modalState.idTipoluogo" placeholder="Tipologia di Luogo di Installazione" /><label for="idTipoluogo">Tipologia Luogo*</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>

      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>REFERENTE PRINCIPALE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="referente" v-model="modalData.indirizzo.princ_nome" type="text" :state="modalState.princ_nome" placeholder="Referente" /><label for="referente">Referente</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="modalData.indirizzo.princ_email" type="text" :state="modalState.princ_email" placeholder="Email del referente" /><label for="email">Email</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cellulare" v-model="modalData.indirizzo.princ_cellulare" type="text" :state="modalState.princ_cellulare" placeholder="Cellulare del referente" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="telefono" v-model="modalData.indirizzo.princ_telefono" type="text" :state="modalState.princ_telefono" placeholder="Telefono del referente" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="indirizzo" v-model="modalData.indirizzo.princ_indirizzo" type="text" :state="modalState.princ_indirizzo" placeholder="Indirizzo del referente" /><label for="indirizzo">Indirizzo</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>PRIMO REFERENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="referente" v-model="modalData.indirizzo.referente1" type="text" :state="modalState.referente1" placeholder="Referente" /><label for="referente">Referente</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="modalData.indirizzo.email1" type="text" :state="modalState.email1" placeholder="Email del referente" /><label for="email">Email</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cellulare" v-model="modalData.indirizzo.cellulare1" type="text" :state="modalState.cellulare1" placeholder="Cellulare del referente" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="telefono" v-model="modalData.indirizzo.telefono1" type="text" :state="modalState.telefono1" placeholder="Telefono del referente" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
      </b-row>

      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>SECONDO REFERENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="referente" v-model="modalData.indirizzo.referente2" type="text" :state="modalState.referente2" placeholder="Referente" /><label for="referente">Referente</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="modalData.indirizzo.email2" type="text" :state="modalState.email2" placeholder="Email del referente" /><label for="email">Email</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cellulare" v-model="modalData.indirizzo.cellulare2" type="text" :state="modalState.cellulare2" placeholder="Cellulare del referente" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="telefono" v-model="modalData.indirizzo.telefono2" type="text" :state="modalState.telefono2" placeholder="Telefono del referente" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
      </b-row>

      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>NOTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="modalData.indirizzo.note" :state="modalState.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" v-on:click="addIndirizzo()">Aggiungi</b-button>
        <b-button class="float-right" v-on:click="modal.indirizzo = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare: <br><strong>{{modalData.delete.via}} {{modalData.delete.civico}}, {{modalData.delete.cap}} {{modalData.delete.comune}}({{modalData.delete.provincia}}), {{modalData.delete.nazione}}</strong></p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteIndirizzo(modalData.delete)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { globalConf } from '../../config.global'

var map
var markers

export default {
  name: 'clientiadd',
  data() {
    return {
      campi: [
        {key: 'indirizzo', label: 'Indirizzo', sortable: true},
        {key: 'residenza', label: 'Residenza/Ubicazione', sortable: true}, 
        {key: 'princ_nome', label: 'Referente', sortable: true},
        {key: 'princ_cellulare', label: 'Cellulare', sortable: true},
        {key: 'princ_telefono', label: 'Telefono', sortable: true},
        {key: 'princ_email', label: 'Email', sortable: true},
        //{key: 'note', label: 'Note', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,


      tmp: {
        address_map: ''
      },
      state: {
        codice: null,
        denominazione: null,
        idTipocliente: null,
        cf: null,
        piva: null,
        cont1: null,
        cont2: null,
        website: null,
        email: null,
        cellulare: null,
        telefono: null,
        fax: null,
        note: null,
      },
      modalState: {
        idTipoluogo: null,
        search_address: null,
        via: null,
        civico: null,
        nazione: null,
        provincia: null,
        comune: null,
        cap: null,
        princ_nome: null,
        princ_cellulare: null,
        princ_telefono: null,
        princ_email: null,
        princ_indirizzo: null,
        referente1: null,
        email1: null,
        cellulare1: null,
        telefono1: null,
        referente2: null,
        email2: null,
        cellulare2: null,
        telefono2: null,
        note: null
      },
      option: {
        tipoclienti: [],
        tipoluogo: []
      },
      formData:{
        cliente: {
          codice: '',
          denominazione: '',
          idTipocliente: null,
          cf: '',
          piva: '',
          indirizzi: [],
          cont1: '',
          cont2: '',
          website: '',
          email: '',
          cellulare: '',
          telefono: '',
          fax: '',
          note: ''
        }
      },
      modal: {
        indirizzo: false,
        delete: false
      },
      modalData: {
        indirizzo: {
          idTipoluogo: null,
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          residenza: false,
          princ_nome: '',
          princ_cellulare: '',
          princ_telefono: '',
          princ_email: '',
          princ_indirizzo: '',
          referente1: '',
          email1: '',
          cellulare1: '',
          telefono1: '',
          referente2: '',
          email2: '',
          cellulare2: '',
          telefono2: '',
          note: ''
        },
        delete: {}
      },
      flag: {
        edit_indirizzo: false,
        maps: true
      }
    }
  },
  created: function(){
    this.option.tipoclienti = this.getListOption("tipoclienti")
    this.option.tipoluogo = this.getListOption("tipoluogo")
    Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
    .then(() => {
      //this.loadMap()
    })
    .catch((e) => {
      console.log("Errore durante il caricamento di Google Maps!\n"+e)
    })
  },
  methods: {
    loadMap(){
      map = new google.maps.Map(document.getElementById('ubicazione_map'), {
        center: {lat: 42.504154, lng: 12.646361},
        streetViewControl: false,
        zoom: 6
      })

      var input = document.getElementById('search_box')
      var searchBox = new google.maps.places.SearchBox(input)
      //map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      var localthis = this

      map.addListener('bounds_changed', function() {
        searchBox.setBounds(map.getBounds())
      })

      markers = []

      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()

        localthis.setMap(places)
      })
    },
    setMap(places){
      this.state.search_address = null
      var check_msg = this.checkAddress(places)
      if(check_msg.length > 0){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: check_msg[1],
          type: check_msg[0]
        })

        if(check_msg[0] == "error")
          this.state.search_address = false

        places = []
      }else{
        this.setByPlace(places[0].formatted_address)
      }

      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []

      var bounds = new google.maps.LatLngBounds()
      places.forEach(function(place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry")
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }

        markers.push(new google.maps.Marker({
          map: map,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }))

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      map.fitBounds(bounds)
    },
    checkAddress(places){
      if(!places || places.length == 0 || places.length > 1){
        return ['info', "Non è stato possibile trovare il punto esatto dell'indirizzo fornito!"]
      }

      var luogo = places[0].formatted_address

      document.getElementById('search_box').value = luogo
      
      var campi = luogo.split(",")

      if(campi.length != 4){
        return ["error", "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"]
      }

      if(campi[1].trim().split(" ").length != 1){
        return ["error", "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"]
      }

      if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
        return ["error", "Attualmente sono supportati solo indirizzi italiani! Per qualsiasi dubbio contattare l'assistenza."]
      }

      var sub_campi = campi[2].trim().split(" ")

      if(sub_campi.length < 3)
        return ["error", "L'indirizzo inserito non è valido!"]

      if(isNaN(Number.parseInt(sub_campi[0].trim())))
        return ["error", "L'indirizzo inserito non contiene un CAP valido! Riprovare."]

      if(sub_campi[sub_campi.length - 1].trim().length != 2)
        return ["error", "La provincia inserita non è valida!"]

      return []
    },
    toggleAddress(){
      this.modalData.indirizzo.via = ''
      this.modalData.indirizzo.civico = ''
      this.modalData.indirizzo.nazione = ''
      this.modalData.indirizzo.cap = ''
      this.modalData.indirizzo.provincia = ''
      this.modalData.indirizzo.comune = ''

      document.getElementById('search_box').value = ""

      this.flag.maps = !this.flag.maps
    },
    checkManualAddress(){
      var msg = ""
      if(!(this.modalData.indirizzo.via && this.modalData.indirizzo.via.length > 0 && this.modalData.indirizzo.via.length <= 200)){
        this.state.via = false
        if(msg == "") msg = "Il campo Via non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 200)!" 
      }

      if(!(this.modalData.indirizzo.civico && this.modalData.indirizzo.civico.length > 0 && this.modalData.indirizzo.civico.length <= 10)){
        this.state.civico = false
        if(msg == "") msg = "Il campo Civico non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 10)!" 
      }
      
      if(!(this.modalData.indirizzo.comune && this.modalData.indirizzo.comune.length > 0 && this.modalData.indirizzo.comune.length <= 200)){
        this.state.comune = false
        if(msg == "") msg = "Il campo Comune non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 200)!" 
      }
      
      if(!(this.modalData.indirizzo.cap && this.modalData.indirizzo.cap.length > 0 && this.modalData.indirizzo.cap.length <= 10)){
        this.state.cap = false
        if(msg == "") msg = "Il campo cap non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 10)!" 
      }
      
      if(!(this.modalData.indirizzo.provincia && this.modalData.indirizzo.provincia.length > 0 && this.modalData.indirizzo.provincia.length <= 200)){
        this.state.provincia = false
        if(msg == "") msg = "Il campo Provincia non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 200)!" 
      }

      if(!(this.modalData.indirizzo.nazione && this.modalData.indirizzo.nazione.length > 0 && this.modalData.indirizzo.nazione.length <= 100)){
        this.state.nazione = false
        if(msg == "") msg = "Il campo Nazione non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 100)!" 
      }

      return msg
    },
    setByPlace(places){
      console.log(places)

      document.getElementById('search_box').value = places

      var campi = places.split(",")

      this.modalData.indirizzo.via = campi[0]
      this.modalData.indirizzo.civico = campi[1]
      this.modalData.indirizzo.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo

      var sub_campi = campi[2].split(" ")

      this.modalData.indirizzo.cap = sub_campi[1]
      this.modalData.indirizzo.provincia = sub_campi[sub_campi.length - 1]
      this.modalData.indirizzo.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
    },
    addCliente(){
      Vue.http.post('cliente/add', this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Cliente aggiunto con successo!',
            type: 'success'
          })
          this.$router.push('/clienti')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la registrazione',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    getListOption(tipo){
      var list = []

      Vue.http.post('selectlist/'+tipo, {}, {credentials : true}).then(response => {
        if(response.body.success){
            for(var i=0; i<response.body.list.length; i++){
              if(response.body.list[i].codice)
                list.push({value: response.body.list[i].id, text: response.body.list[i].codice+" - "+response.body.list[i].nome})
              else
                list.push({value: response.body.list[i].id, text: response.body.list[i].nome})
            }
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista "+tipo+" non caricata correttamente.",
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Lista "+tipo+" non caricata correttamente.",
            type: 'error'
        })
      })

      return list
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async openModalAggiungiIndirizzo(item = null){
      if(item == null){
        this.modalData.indirizzo = {
          idTipoluogo: null,
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          residenza: false,
          princ_nome: '',
          princ_cellulare: '',
          princ_telefono: '',
          princ_email: '',
          referente1: '',
          email1: '',
          cellulare1: '',
          telefono1: '',
          referente2: '',
          email2: '',
          cellulare2: '',
          telefono2: '',
          note: ''
        }
        this.flag.edit_indirizzo = false
        this.flag.maps = true
      }else{
        this.modalData.indirizzo = item

        if(this.modalData.indirizzo.nazione.slice(0, 2) == "M_"){
          this.modalData.indirizzo.nazione = this.modalData.indirizzo.nazione.slice(2)
          this.flag.maps = false
        }else{
          this.flag.maps = true
        }
        this.flag.edit_indirizzo = true
      }

      this.modal.indirizzo = true

      while(!document.getElementById('ubicazione_map')) {
        await new Promise(r => setTimeout(r, 500))
      }
      this.loadMap()


      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []

      map.setCenter({lat: 42.504154, lng: 12.646361})
      map.setZoom(6)

      if(this.flag.edit_indirizzo && this.flag.maps){
        document.getElementById('search_box').value = item.via+", "+item.civico+", "+item.cap+" "+item.comune+" "+item.provincia+", "+item.nazione

        var localthis = this
        
        var service = new google.maps.places.PlacesService(map);
        
        var request = {
          query: document.getElementById('search_box').value,
          fields: ['formatted_address', 'geometry', 'html_attributions', 'icon', 'id', 'name', 'place_id', 'plus_code', 'reference', 'types'],
        }

        service.findPlaceFromQuery(request, function(results, status) {
          localthis.setMap(results)
        })
      }else
        document.getElementById('search_box').value = ""
    },
    addIndirizzo(){
      for(var i=0; i<Object.keys(this.modalState).length; i++){
        this.modalState[Object.keys(this.modalState)[i]] = null
      }

      if(this.modalData.indirizzo.via == '' || this.modalData.indirizzo.civico == '' || this.modalData.indirizzo.nazione == '' ||
          this.modalData.indirizzo.provincia == '' || this.modalData.indirizzo.comune == '' || this.modalData.indirizzo.cap == ''){
        this.modalState.search_address = false
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: "Assicurati di aver selezionato correttamente la tua residenza/ubicazione e di aver selezionato un punto bel preciso!",
          type: 'error'
        })
        return
      }

      var msg = ""
      if(!this.modalData.indirizzo.idTipoluogo && this.modalData.indirizzo.idTipoluogo == null){
        this.modalState.idTipoluogo = false
        if(msg == "")
          msg = "Devi selezionata una Tipologia di Luogo Installazione!"
      }

      if(this.modalData.indirizzo.princ_nome && this.modalData.indirizzo.princ_nome != '' && this.modalData.indirizzo.princ_nome.length > 150){
        this.modalState.princ_nome = false
        if(msg == "")
          msg = "Il campo Referente del Referente Principale è troppo lungo!"
      }
      
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(this.modalData.indirizzo.princ_email && this.modalData.indirizzo.princ_email != '' && (this.modalData.indirizzo.princ_email.length > 70 || !re.test(String(this.modalData.indirizzo.princ_email).toLowerCase()))){
        this.modalState.princ_email = false
        if(msg == "")
          msg = "Il campo Email del Referente Principale è troppo lungo o non valido!"
      }

      if(this.modalData.indirizzo.princ_cellulare && this.modalData.indirizzo.princ_cellulare != '' && this.modalData.indirizzo.princ_cellulare.length > 20){
        this.modalState.princ_cellulare = false
        if(msg == "")
          msg = "Il campo Cellulare del Referente Principale è troppo lungo!"
      }

      if(this.modalData.indirizzo.princ_telefono && this.modalData.indirizzo.princ_telefono != '' && this.modalData.indirizzo.princ_telefono.length > 20){
        this.modalState.princ_telefono = false
        if(msg == "")
          msg = "Il campo Telefono del Referente Principale è troppo lungo!"
      }

      if(this.modalData.indirizzo.referente1 && this.modalData.indirizzo.referente1 != '' && this.modalData.indirizzo.referente1.length > 250){
        this.modalState.referente1 = false
        if(msg == "")
          msg = "Il campo Referente del Primo Referente è troppo lungo!"
      }
      
      if(this.modalData.indirizzo.email1 && this.modalData.indirizzo.email1 != '' && (this.modalData.indirizzo.email1.length > 70 || !re.test(String(this.modalData.indirizzo.email1).toLowerCase()))){
        this.modalState.email1 = false
        if(msg == "")
          msg = "Il campo Email del Primo Referente è troppo lungo o non valido!"
      }

      if(this.modalData.indirizzo.cellulare1 && this.modalData.indirizzo.cellulare1 != '' && this.modalData.indirizzo.cellulare1.length > 20){
        this.modalState.cellulare1 = false
        if(msg == "")
          msg = "Il campo Cellulare del Primo Referente è troppo lungo!"
      }

      if(this.modalData.indirizzo.telefono1 && this.modalData.indirizzo.telefono1 != '' && this.modalData.indirizzo.telefono1.length > 20){
        this.modalState.telefono1 = false
        if(msg == "")
          msg = "Il campo Telefono del Primo Referente è troppo lungo!"
      }

      if(this.modalData.indirizzo.referente2 && this.modalData.indirizzo.referente2 != '' && this.modalData.indirizzo.referente2.length > 250){
        this.modalState.referente2 = false
        if(msg == "")
          msg = "Il campo Referente del Secondo Referente è troppo lungo!"
      }
      
      if(this.modalData.indirizzo.email2 && this.modalData.indirizzo.email2 != '' && (this.modalData.indirizzo.email2.length > 70 || !re.test(String(this.modalData.indirizzo.email2).toLowerCase()))){
        this.modalState.email2 = false
        if(msg == "")
          msg = "Il campo Email del Secondo Referente è troppo lungo o non valido!"
      }

      if(this.modalData.indirizzo.cellulare2 && this.modalData.indirizzo.cellulare2 != '' && this.modalData.indirizzo.cellulare2.length > 20){
        this.modalState.cellulare2 = false
        if(msg == "")
          msg = "Il campo Cellulare del Secondo Referente è troppo lungo!"
      }

      if(this.modalData.indirizzo.telefono2 && this.modalData.indirizzo.telefono2 != '' && this.modalData.indirizzo.telefono2.length > 20){
        this.modalState.telefono2 = false
        if(msg == "")
          msg = "Il campo Telefono del Secondo Referente è troppo lungo!"
      }

      if(this.modalData.indirizzo.note && this.modalData.indirizzo.note != '' && this.modalData.indirizzo.note.length > 500){
        this.modalState.note = false
        if(msg == "")
          msg = "Il campo Note è troppo lungo!"
      }

      if(msg != ""){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: msg,
          type: 'error'
        })
        return
      }

      if(this.flag.edit_indirizzo){
        var tmp = JSON.parse(JSON.stringify(this.modalData.indirizzo))
        //delete this.modalData.indirizzo

        var find_el = JSON.stringify(this.modalData.indirizzo)
        this.formData.cliente.indirizzi = this.formData.cliente.indirizzi.filter(e => {
          return JSON.stringify(e) !== find_el
        })
        console.log(this.formData.cliente.indirizzi)
        this.modalData.indirizzo = tmp
      }

      var ind_x = JSON.parse(JSON.stringify(this.modalData.indirizzo))
      if(!this.flag.maps)
        ind_x.nazione = "M_"+ind_x.nazione
      
      this.formData.cliente.indirizzi.push(ind_x)
      this.totalRows = this.formData.cliente.indirizzi.length

      document.getElementById('search_box').value = ""
      this.modalData.indirizzo = {
          idTipoluogo: null,
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          residenza: false,
          princ_nome: '',
          princ_cellulare: '',
          princ_telefono: '',
          princ_email: '',
          referente1: '',
          email1: '',
          cellulare1: '',
          telefono1: '',
          referente2: '',
          email2: '',
          cellulare2: '',
          telefono2: '',
          note: ''
        }

      this.modal.indirizzo = false
    },
    openModalDeleteIndirizzo(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deleteIndirizzo(item){
      var index = this.formData.cliente.indirizzi.indexOf(item)
      this.formData.cliente.indirizzi = this.formData.cliente.indirizzi.filter((e, indexE) => {
        if(index == indexE)
          return false
        return true
      })
      if(this.currentPage != 1)
        this.currentPage--

      this.totalRows = this.formData.cliente.indirizzi.length

      this.modalData.delete = {}
      this.modal.delete = false
    }
  }
}
</script>

<style>
/* AUTOCOMPLETE GOOGLE FIX */
.pac-container, .pac-item{
  z-index: 2147483647 !important;
}
</style>

<style scoped>
#search_box{
  text-indent: 100px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#referente{
  text-indent: 100px;
}

#codice{
  text-indent: 90px;
}

#denominazione{
  text-indent: 150px;
}

#cf{
  text-indent: 140px;
}

#piva{
  text-indent: 110px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#email{
  text-indent: 85px;
}

#cont1{
  text-indent: 105px;
}

#cont2{
  text-indent: 110px;
}

#idTipocliente{
  text-indent: 155px;
}

#indirizzo{
  text-indent: 90px;
}

#idTipoluogo{
  text-indent: 155px;
}

#via{
  text-indent: 65px;
}

#civico{
  text-indent: 85px;
}

#comune{
  text-indent: 105px;
}

#cap{
  text-indent: 75px;
}

#provincia{
  text-indent: 110px;
}

#nazione{
  text-indent: 100px;
}
</style>